// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"ce28ab66","870":"b6554015"}[chunkId] + ".chunk.css";
};